import { LibraryFilterArg } from '../types/library-filter-arg'

export function mapLibraryFilters(filters: LibraryFilterArg) {
  const {
    tags = [],
    servers = [],
    languages = [],
    applications = [],
    licenses = [],
    grades = [],
    status = [],
    usage = [],
    quickFilter,
    filterText,
    environments = []
  } = filters

  return {
    filterText,
    quickFilter,
    apps: applications,
    servers,
    tags,
    languages,
    licenses,
    grades,
    status,
    environments,
    includeUsed: usage.indexOf('used') > -1,
    includeUnused: usage.indexOf('unused') > -1
  }
}

export function appendLibraryFiltersToBody(
  filters: LibraryFilterArg | undefined
) {
  if (filters) {
    const {
      filterText,
      quickFilter,
      apps,
      servers,
      tags,
      languages,
      licenses,
      grades,
      status,
      includeUsed,
      includeUnused,
      environments
    } = mapLibraryFilters(filters)

    let body: any = {
      quickFilter: quickFilter ? quickFilter : 'ALL',
      apps,
      servers,
      tags,
      languages,
      licenses,
      grades,
      status,
      includeUsed,
      includeUnused,
      environments
    }

    if (filterText) {
      body = {
        ...body,
        q: filterText
      }
    }

    return body
  }
  return {}
}
